/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Views_Builtin_Recently_ClosedInputs */

const en_views_builtin_recently_closed = /** @type {(inputs: Views_Builtin_Recently_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recently closed`)
};

const de_views_builtin_recently_closed = /** @type {(inputs: Views_Builtin_Recently_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kürzlich erledigt`)
};

/**
* | output |
* | --- |
* | "Recently closed" |
*
* @param {Views_Builtin_Recently_ClosedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_builtin_recently_closed = /** @type {((inputs?: Views_Builtin_Recently_ClosedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_Builtin_Recently_ClosedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_builtin_recently_closed(inputs)
	return en_views_builtin_recently_closed(inputs)
});